export default function CsharpCompiler() {
  return (
    <h2>Csharp Compiler</h2>
  );
}
